import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';
import SchoolDetail from 'components/School/SchoolDetail';
import BulkInviteCreation from 'components/Invitation/BulkInviteCreation';

class TeacherDashBoard extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
  };

  render() {
    const {
      user: {activeSchool},
    } = this.props;
    return (
      <Switch>
        <Route exact path="/" render={() => <SchoolDetail school={activeSchool} />} />
        <Route path="/bulk-invite" component={BulkInviteCreation} />
        <Redirect to="/" />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  const {account} = state;
  const user = account.get('user').toJS();
  return {
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TeacherDashBoard);
